// 键盘事件处理混入
export default {
    data() {
        return {};
    },
    mounted() { },
    beforeDestroy() { },
    methods: {
        mzPromotion(plan) {
            console.log("按商品分类满赠促销（支持多批号）");
            console.log("newPromotions", plan);
            // 1. 首先检查条件商品是否满足
            let conditionMet = false;
            let matchedConditionItems = [];

            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 记录购物车中满足条件的商品
                const conditionItemsInCart = [];

                // 遍历条件商品列表（支持多批号）
                plan.planBgmIdList.forEach((conditionItem) => {
                    // 使用 filter 获取所有匹配的批号，而不是只找第一个
                    const matchedCartItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem && !item.isGift
                    );

                    if (matchedCartItems.length > 0) {
                        console.log(`🛒 找到商品 ${conditionItem} 的 ${matchedCartItems.length} 个批号`);

                        // 为每个批号创建条件项
                        matchedCartItems.forEach((matchedCartItem) => {
                            plan.conBgmTypeList.forEach((conBgmItem) => {
                                console.log("conBgmItem", conBgmItem);

                                conditionItemsInCart.push({
                                    cartItem: matchedCartItem,
                                    actual: matchedCartItem.quantity,
                                    priceSet: conBgmItem.priceSet,
                                    batchInfo: `批号: ${matchedCartItem.sterBatchno || '无'}`
                                });
                            });
                        });
                    } else {
                        console.log(`⚠️ 未找到商品 ${conditionItem} 的任何批号`);
                    }
                });
                console.log(conditionItemsInCart, "conditionItemsInCart88（多批号）");

                // 检查是否满足所有条件商品要求
                if (conditionItemsInCart.length > 0) {
                    // 检查每个条件商品的数量是否满足要求
                    conditionMet = true;
                    matchedConditionItems = conditionItemsInCart;
                } else {
                    console.log("购物车中没有找到条件商品");
                }
            }

            // 2. 如果条件满足，根据priceSet处理价格
            if (conditionMet) {
                console.log(matchedConditionItems, "matchedConditionItems666");

                // 获取priceSet值，默认为1

                const priceSet = matchedConditionItems[0].priceSet;
                console.log("价格设置方式 priceSet:", priceSet);
                // 根据不同的priceSet值处理价格
                switch (priceSet) {
                    case 1: // 保持现状去赠送商品
                        console.log("保持现状，赠送商品");
                        // 处理积分促销
                        this.handlePointsPromotionForMz(plan, priceSet);
                        this.addGiftsToCartII(plan);
                        break;

                    case 2: // 全部恢复原价，赠送商品（支持多批号）
                        console.log("恢复原价后，再优惠最低价格商品（支持多批号）");
                        if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                            // 如果有指定条件商品，处理所有批号
                            plan.planBgmIdList.forEach((conditionItem) => {
                                // 使用 filter 获取所有匹配的批号
                                const matchedCartItems = this.cartItems.filter(
                                    (item) => item.bgmId === conditionItem && !item.isGift
                                );

                                console.log(`🔄 处理商品 ${conditionItem} 的 ${matchedCartItems.length} 个批号`);

                                matchedCartItems.forEach((matchedCartItem, index) => {
                                    console.log(`处理批号 ${index + 1}: ${matchedCartItem.sterBatchno || '无'}`, matchedCartItem);

                                    // 恢复原价
                                    const originalPrice = Number(matchedCartItem.price);
                                    matchedCartItem.changePrice = originalPrice;
                                    matchedCartItem.actualPrice = originalPrice;
                                    matchedCartItem.amount = Number(this.$common.getDecimalInfo(3, originalPrice * matchedCartItem.quantity));
                                    matchedCartItem.discountInfo = `${matchedCartItem.bgmName}(批号:${matchedCartItem.sterBatchno || '无'})：全部恢复原价`;
                                    matchedCartItem.isDiscounted = true;
                                    matchedCartItem.isPointPromotion = true;

                                    console.log(`✅ 批号 ${matchedCartItem.sterBatchno || '无'} 恢复原价完成: ${originalPrice}元`);
                                });
                            });
                        }

                        // 处理积分促销
                        this.handlePointsPromotionForMz(plan, priceSet);
                        this.addGiftsToCartII(plan);
                        // this.applyLowestPriceDiscount(plan, matchedConditionItems, priceSet);
                        break;

                    default:
                        console.log(
                            "未知的价格设置方式:",
                            priceSet,
                            "默认使用保持现状模式"
                        );
                    // this.applyLowestPriceDiscount(plan, matchedConditionItems, 1);
                }
            } else {
                console.log("未满足条件，不应用价格规则");
            }


        },
        addGiftsToCartII(plan) {
            console.log("🎁 开始添加赠品到购物车（支持多批号）", plan);

            // 计算重复赠送倍数
            let mzIsRepeatNum = 1;
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量（支持多批号）
                let qualifiedQuantity = 0;

                if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                    // 如果有指定条件商品，计算所有批号的总数量
                    plan.planBgmIdList.forEach((conditionItem) => {
                        console.log(`🔍 计算商品 ${conditionItem} 的数量`);

                        // 使用 filter 获取所有匹配的批号
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === conditionItem && !item.isGift
                        );

                        if (matchedCartItems.length > 0) {
                            // 计算所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);
                            qualifiedQuantity += totalQuantity;

                            console.log(`📦 商品 ${conditionItem} 共 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                            matchedCartItems.forEach((item, index) => {
                                console.log(`   批号 ${index + 1}: ${item.sterBatchno || '无'} - 数量: ${item.quantity}`);
                            });
                        } else {
                            console.log(`⚠️ 商品 ${conditionItem} 未找到任何批号`);
                        }
                    });
                }

                // 根据条件商品数量要求计算赠送倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);

                console.log(
                    `🎯 赠品重复赠送计算（多批号）: 符合条件商品总数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 赠送倍数=${mzIsRepeatNum}`
                );

                // 如果倍数为0，说明不满足条件，不赠送
                if (mzIsRepeatNum <= 0) {
                    console.log("❌ 不满足重复赠送条件，不赠送赠品");
                    return;
                }
            }
            // 将倍数信息传递给子方法
            plan._calculatedRepeatNum = mzIsRepeatNum;

            if (plan.mzGiftNumType === 1) {
                this.addSelectedSingleGift(plan);
            } else {
                this.addMultipleGifts(plan);
            }
        },
        yhqPromotion(plan) {
            console.log("按商品分类优惠券促销（支持多批号）");
            console.log("newPromotions", plan);

            // 1. 首先检查条件商品是否满足
            let conditionMet = false;
            let matchedConditionItems = [];

            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 记录购物车中满足条件的商品
                const conditionItemsInCart = [];

                // 遍历条件商品列表（支持多批号）
                plan.planBgmIdList.forEach((conditionItem) => {
                    // 使用 filter 获取所有匹配的批号，而不是只找第一个
                    const matchedCartItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem && !item.isGift
                    );

                    if (matchedCartItems.length > 0) {
                        console.log(`🛒 优惠券促销 - 找到商品 ${conditionItem} 的 ${matchedCartItems.length} 个批号`);

                        // 为每个批号创建条件项
                        matchedCartItems.forEach((matchedCartItem) => {
                            plan.conBgmTypeList.forEach((conBgmItem) => {
                                console.log("conBgmItem", conBgmItem);

                                conditionItemsInCart.push({
                                    cartItem: matchedCartItem,
                                    actual: matchedCartItem.quantity,
                                    priceSet: conBgmItem.priceSet,
                                    batchInfo: `批号: ${matchedCartItem.sterBatchno || '无'}`
                                });
                            });
                        });
                    } else {
                        console.log(`⚠️ 优惠券促销 - 未找到商品 ${conditionItem} 的任何批号`);
                    }
                });
                console.log(conditionItemsInCart, "conditionItemsInCart88（多批号）");

                // 检查是否满足所有条件商品要求
                if (conditionItemsInCart.length > 0) {
                    // 检查每个条件商品的数量是否满足要求
                    conditionMet = true;
                    matchedConditionItems = conditionItemsInCart;
                } else {
                    console.log("购物车中没有找到条件商品");
                }
            }

            // 2. 如果条件满足，根据priceSet处理价格
            if (conditionMet) {
                // 计算重复赠送倍数（支持多批号）
                let mzIsRepeatNum = 1;
                if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                    // 计算符合条件的商品数量（支持多批号）
                    let qualifiedQuantity = 0;

                    if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                        // 如果有指定条件商品，计算所有批号的总数量
                        plan.planBgmIdList.forEach((conditionItem) => {
                            console.log(`🔍 优惠券促销 - 计算商品 ${conditionItem} 的数量`);

                            // 使用 filter 获取所有匹配的批号
                            const matchedCartItems = this.cartItems.filter(
                                (item) => item.bgmId === conditionItem && !item.isGift
                            );

                            if (matchedCartItems.length > 0) {
                                // 计算所有批号的总数量
                                const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);
                                qualifiedQuantity += totalQuantity;

                                console.log(`📦 优惠券促销 - 商品 ${conditionItem} 共 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                                matchedCartItems.forEach((item, index) => {
                                    console.log(`   批号 ${index + 1}: ${item.sterBatchno || '无'} - 数量: ${item.quantity}`);
                                });
                            } else {
                                console.log(`⚠️ 优惠券促销 - 商品 ${conditionItem} 未找到任何批号`);
                            }
                        });
                    }

                    // 根据条件商品数量要求计算赠送倍数（向下取整）
                    const conditionNum = plan.mzConBgmNum || 1;
                    mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);

                    console.log(
                        `🎯 优惠券促销重复赠送计算（多批号）: 符合条件商品总数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 赠送倍数=${mzIsRepeatNum}`
                    );

                    // 如果倍数为0，说明不满足条件，不赠送
                    if (mzIsRepeatNum <= 0) {
                        console.log("❌ 不满足重复赠送条件，不赠送优惠券");
                        return;
                    }
                }
                console.log(matchedConditionItems, "matchedConditionItems");
                // 获取priceSet值，默认为1
                const priceSet = matchedConditionItems[0].priceSet;
                console.log("价格设置方式 priceSet:", priceSet);
                // 根据不同的priceSet值处理价格
                switch (priceSet) {
                    case 1: // 保持现状去优惠最低价格品种金额
                        console.log("保持现状，赠送优惠券");
                        // 处理积分促销
                        this.handlePointsPromotionForYhq(plan, priceSet, mzIsRepeatNum);
                        // 优惠券信息保存到giftYhqList，付款时传递
                        // 赠送优惠券
                        this.addCouponsToListII(plan);
                        break;

                    case 2: // 全部恢复原价，然后再优惠最低价格品种金额
                        console.log("恢复原价后，赠送优惠券");
                        // 处理积分促销
                        this.handlePointsPromotionForYhq(plan, priceSet, mzIsRepeatNum);
                        // 然后赠送优惠券
                        // this.addCouponsToList(plan);
                        break;

                    default:
                        console.log(
                            "未知的价格设置方式:",
                            priceSet,
                            "默认使用保持现状模式"
                        );
                    // this.applyLowestPriceDiscount(plan, matchedConditionItems, 1);
                }

            } else {
                console.log("未满足条件，不应用价格规则");
            }
            // 更新总计金额
            this.updateTotal();

        },
        addCouponsToListII(plan) {
            console.log('处理优惠券赠送，促销方案:', plan.planName);

            if (plan.mzGiftNumType === 1) {
                // 任选一个优惠券模式
                this.addSelectedSingleCouponII(plan);
            } else {
                // 多选模式，赠送所有配置的优惠券
                this.addMultipleCouponsII(plan);
            }
        },
        addSelectedSingleCouponII(plan) {
            if (!this.selectedSingleCoupon) {
                console.log('未选择任何优惠券');
                return;
            }
            // 计算重复赠送倍数（支持多批号）
            let mzIsRepeatNum = 1;
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量（支持多批号）
                let qualifiedQuantity = 0;

                if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                    // 如果有指定条件商品，计算所有批号的总数量
                    plan.planBgmIdList.forEach((conditionItem) => {
                        console.log(`🔍 优惠券赠送 - 计算商品 ${conditionItem} 的数量`);

                        // 使用 filter 获取所有匹配的批号
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === conditionItem && !item.isGift
                        );

                        if (matchedCartItems.length > 0) {
                            // 计算所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);
                            qualifiedQuantity += totalQuantity;

                            console.log(`📦 优惠券赠送 - 商品 ${conditionItem} 共 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                        } else {
                            console.log(`⚠️ 优惠券赠送 - 商品 ${conditionItem} 未找到任何批号`);
                        }
                    });
                }

                // 根据条件商品数量要求计算赠送倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);

                console.log(
                    `🎯 优惠券重复赠送计算（多批号）: 符合条件商品总数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 赠送倍数=${mzIsRepeatNum}`
                );

                // 如果倍数为0，说明不满足条件，不赠送
                if (mzIsRepeatNum <= 0) {
                    console.log("❌ 不满足重复赠送条件，不赠送优惠券");
                    return;
                }
            }
            // 查找选中的优惠券
            const selectedCoupon = this.availableCouponList.find(coupon =>
                coupon.yhqId === this.selectedSingleCoupon && coupon.planId === plan.planId
            );
            if (selectedCoupon && selectedCoupon.inputNum > 0) {
                console.log('赠送选中的优惠券:', selectedCoupon.yhqName, '数量:', selectedCoupon.inputNum * mzIsRepeatNum);
                this.yhqGift.push({
                    ...selectedCoupon,
                    inputNum: selectedCoupon.inputNum * mzIsRepeatNum,
                    giftNum: selectedCoupon.inputNum * mzIsRepeatNum
                })
                console.log('优惠券列表this.yhqGift', this.yhqGift);
            }
        },
        addMultipleCouponsII(plan) {
            if (!plan.giftYhqList || !Array.isArray(plan.giftYhqList)) {
                console.log('促销方案没有配置优惠券列表');
                return;
            }
            // 计算重复赠送倍数
            let mzIsRepeatNum = 1;
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量
                let qualifiedQuantity = 0;

                if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                    // 如果有指定条件商品，计算条件商品的总数量
                    plan.planBgmIdList.forEach((conditionItem) => {
                        console.log(123123123, conditionItem);

                        const matchedCartItem = this.cartItems.find(
                            (item) => item.bgmId === conditionItem && !item.isGift
                        );
                        if (matchedCartItem) {
                            qualifiedQuantity += matchedCartItem.quantity;
                        }
                    });
                }

                // 根据条件商品数量要求计算赠送倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);

                console.log(
                    `赠品重复赠送计算: 符合条件商品数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 赠送倍数=${mzIsRepeatNum}`
                );

                // 如果倍数为0，说明不满足条件，不赠送
                if (mzIsRepeatNum <= 0) {
                    console.log("不满足重复赠送条件，不赠送赠品");
                    return;
                }
            }
            // 总是添加方案配置的优惠券（不依赖用户选择状态）
            plan.giftYhqList.forEach(coupon => {
                const baseCouponQuantity = coupon.giftNum || 1;
                const finalCouponQuantity = baseCouponQuantity * mzIsRepeatNum;
                console.log(`优惠券 ${coupon.yhqName}: 基础数量=${baseCouponQuantity}, 倍数=${mzIsRepeatNum}, 最终数量=${finalCouponQuantity}`);

                // 检查是否已存在相同的优惠券，避免重复添加
                const existingIndex = this.yhqGift.findIndex(existing =>
                    existing.yhqId === coupon.yhqId && existing.planId === plan.planId
                );

                const couponItem = {
                    ...coupon,
                    planId: plan.planId,
                    planName: plan.planName,
                    inputNum: finalCouponQuantity,
                    giftNum: finalCouponQuantity
                };

                if (existingIndex >= 0) {
                    // 如果已存在，更新数量
                    this.yhqGift[existingIndex] = couponItem;
                    console.log('更新已存在的优惠券:', coupon.yhqName);
                } else {
                    // 如果不存在，添加新的
                    this.yhqGift.push(couponItem);
                    console.log('添加新的优惠券:', coupon.yhqName);
                }

                console.log('优惠券列表this.yhqGift', this.yhqGift);
            });
        },
        jifenPromotion(plan) {
            console.log("🎯 积分促销处理（支持多批号）");
            console.log("积分促销方案", plan);

            // 1. 首先检查条件商品是否满足
            let conditionMet = false;
            let matchedConditionItems = [];

            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 记录购物车中满足条件的商品（支持多批号）
                const conditionItemsInCart = [];

                // 遍历条件商品列表
                plan.planBgmIdList.forEach((conditionItem) => {
                    // 查找所有匹配的商品（包括不同批号）
                    const matchedCartItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem && !item.isGift
                    );

                    if (matchedCartItems.length > 0) {
                        // 计算该商品所有批号的总数量
                        const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);

                        plan.conBgmTypeList.forEach((conBgmItem) => {
                            console.log("conBgmItem", conBgmItem);

                            // 为每个批号创建条件项
                            matchedCartItems.forEach(cartItem => {
                                conditionItemsInCart.push({
                                    cartItem: cartItem,
                                    actual: cartItem.quantity,
                                    totalQuantity: totalQuantity, // 该商品所有批号的总数量
                                    priceSet: conBgmItem.priceSet,
                                });
                            });
                        });

                        console.log(`找到商品 ${matchedCartItems[0].bgmName} 的 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                    }
                });
                console.log(conditionItemsInCart, "积分促销conditionItemsInCart（多批号）");

                // 检查是否满足所有条件商品要求
                if (conditionItemsInCart.length > 0) {
                    // 检查每个条件商品的数量是否满足要求
                    conditionMet = true;
                    matchedConditionItems = conditionItemsInCart;
                } else {
                    console.log("购物车中没有找到积分促销条件商品");
                }
            }

            // 2. 如果条件满足，根据priceSet处理价格和积分
            if (conditionMet) {
                console.log(matchedConditionItems, "积分促销matchedConditionItems");

                // 获取priceSet值，默认为1
                const priceSet = matchedConditionItems[0].priceSet;
                console.log("积分促销价格设置方式 priceSet:", priceSet);

                // 根据不同的priceSet值处理价格和积分
                switch (priceSet) {
                    case 1: // 保持现状，赠送积分
                        console.log("保持现状，赠送积分");
                        // 处理积分促销
                        this.handlePointsPromotionForJifen(plan, priceSet);
                        break;

                    case 2: // 全部恢复原价，赠送积分（支持多批号）
                        console.log("恢复原价后，赠送积分（支持多批号）");
                        if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                            // 如果有指定条件商品，处理所有批号
                            plan.planBgmIdList.forEach((conditionItem) => {
                                // 使用 filter 获取所有匹配的批号
                                const matchedCartItems = this.cartItems.filter(
                                    (item) => item.bgmId === conditionItem && !item.isGift
                                );

                                console.log(`🔄 积分促销恢复原价 - 处理商品 ${conditionItem} 的 ${matchedCartItems.length} 个批号`);

                                matchedCartItems.forEach((matchedCartItem, index) => {
                                    console.log(`处理批号 ${index + 1}: ${matchedCartItem.sterBatchno || '无'}`, matchedCartItem);

                                    // 恢复原价
                                    const originalPrice = Number(matchedCartItem.price);
                                    matchedCartItem.changePrice = originalPrice;
                                    matchedCartItem.actualPrice = originalPrice;
                                    matchedCartItem.amount = Number(this.$common.getDecimalInfo(3, originalPrice * matchedCartItem.quantity));
                                    matchedCartItem.discountInfo = `${matchedCartItem.bgmName}(批号:${matchedCartItem.sterBatchno || '无'})：全部恢复原价`;
                                    matchedCartItem.isDiscounted = true;
                                    matchedCartItem.isPointPromotion = true;

                                    console.log(`✅ 积分促销批号 ${matchedCartItem.sterBatchno || '无'} 恢复原价完成: ${originalPrice}元`);
                                });
                            });
                        }

                        // 处理积分促销
                        this.handlePointsPromotionForJifen(plan, priceSet);
                        break;

         

                    default:
                        console.log(
                            "未知的积分促销价格设置方式:",
                            priceSet,
                            "默认使用保持现状模式"
                        );
                        // 处理积分促销
                        this.handlePointsPromotionForJifen(plan, 1);
                }
            } else {
                console.log("未满足积分促销条件，不应用积分促销");
            }

            // 更新总计金额
            this.updateTotal();
        },
        mzDiscount(plan) {
            console.log("按商品分类原品打折促销（支持多批号）");
            console.log("newPromotions", plan);

            // 1. 首先检查条件商品是否满足
            let conditionMet = false;
            let matchedConditionItems = [];
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 记录购物车中满足条件的商品
                const conditionItemsInCart = [];
                // 遍历条件商品列表（支持多批号）
                plan.planBgmIdList.forEach(conditionItem => {
                    // 使用 filter 获取所有匹配的批号，而不是只找第一个
                    const matchedCartItems = this.cartItems.filter(item => item.bgmId === conditionItem && !item.isGift);

                    if (matchedCartItems.length > 0) {
                        console.log(`🛒 原品打折 - 找到商品 ${conditionItem} 的 ${matchedCartItems.length} 个批号`);

                        // 计算所有批号的总数量
                        const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);

                        // 为每个批号创建条件项
                        matchedCartItems.forEach((matchedCartItem) => {
                            console.log(`找到匹配商品: ${matchedCartItem.bgmName} (批号: ${matchedCartItem.sterBatchno || '无'}), 数量: ${matchedCartItem.quantity}`);
                            conditionItemsInCart.push({
                                cartItem: matchedCartItem,
                                conditionItem: conditionItem,
                                required: conditionItem.num || 1,
                                actual: matchedCartItem.quantity,
                                totalQuantity: totalQuantity, // 该商品所有批号的总数量
                                batchInfo: `批号: ${matchedCartItem.sterBatchno || '无'}`
                            });
                        });

                        console.log(`📦 商品 ${conditionItem} 共 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                    } else {
                        console.log(`⚠️ 原品打折 - 未找到商品 ${conditionItem} 的任何批号`);
                    }
                });

                // 检查是否满足所有条件商品要求
                if (conditionItemsInCart.length > 0) {
                    // 检查每个条件商品的数量是否满足要求（按商品汇总检查）
                    const itemQuantityMap = new Map();
                    conditionItemsInCart.forEach(item => {
                        const bgmId = item.conditionItem;
                        if (!itemQuantityMap.has(bgmId)) {
                            itemQuantityMap.set(bgmId, { required: item.required, actual: 0 });
                        }
                        itemQuantityMap.get(bgmId).actual += item.actual;
                    });

                    const allConditionsMet = Array.from(itemQuantityMap.values()).every(item => item.actual >= item.required);

                    if (allConditionsMet) {
                        conditionMet = true;
                        matchedConditionItems = conditionItemsInCart;
                        console.log('✅ 满足所有条件商品要求（多批号）');
                    } else {
                        console.log('❌ 条件商品数量不满足要求（多批号）');
                    }

                } else {
                    console.log('购物车中没有找到条件商品');
                }
            } else if (plan.mzConBgmNum) {
                // 如果只有数量要求，不指定具体商品，则检查购物车总数量
                const totalQuantity = this.cartItems.reduce((sum, item) => sum + item.quantity, 0);
                if (totalQuantity >= plan.mzConBgmNum) {
                    conditionMet = true;
                    console.log('满足总数量要求:', totalQuantity, '>=', plan.mzConBgmNum);
                } else {
                    console.log('不满足总数量要求:', totalQuantity, '<', plan.mzConBgmNum);
                }
            }

            // 2. 如果条件满足，根据priceSet处理价格
            if (conditionMet) {
                // 获取priceSet值，默认为1

                const priceSet = plan.conBgmTypeList && plan.conBgmTypeList.length > 0 ?
                    (plan.conBgmTypeList[0].priceSet || 1) : 1;



                console.log('价格设置方式 priceSet:', priceSet);

                // 根据不同的priceSet值处理价格
                switch (priceSet) {
                    case 1: // 保持现状去打折（支持多批号）
                        if (plan.mzDiscount) {
                            // 应用折扣到指定商品（支持多批号）
                            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                                plan.planBgmIdList.forEach(bgmId => {
                                    console.log(`🔄 应用折扣到商品ID: ${bgmId}`);
                                    // 使用 filter 获取所有匹配的批号
                                    const matchingItems = this.cartItems.filter(item => item.bgmId === bgmId && !item.isGift);

                                    if (matchingItems.length > 0) {
                                        console.log(`📦 原品打折保持现状 - 商品 ${bgmId} 找到 ${matchingItems.length} 个批号`);

                                        matchingItems.forEach((item, index) => {
                                            console.log(`处理批号 ${index + 1}: ${item.bgmName} (批号: ${item.sterBatchno || '无'}), 数量: ${item.quantity}, 条件数量: ${plan.mzConBgmNum}`);

                                            // 不拆分商品，使用混合价格计算
                                            const currentPrice = item.changePrice || item.price; // 当前价格
                                            // 全部数量都满足条件，全部打折（单价保留4位小数）
                                            item.changePrice = Number(this.$common.getDecimalInfo(3, currentPrice * plan.mzDiscount));
                                            item.actualPrice = item.changePrice;
                                            item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                                            item.discountInfo = `${plan.planName}(批号:${item.sterBatchno || '无'})：全部${(plan.mzDiscount * 100).toFixed(1)}折`;
                                            item.mzConType = plan.mzConType;
                                            item.mzGiftType = plan.mzGiftType;
                                            item.planType = plan.planType;
                                            item.isDiscounted = true;

                                            console.log(`✅ 原品打折批号 ${item.sterBatchno || '无'} 处理完成: 原价${currentPrice}元, 折后价${item.changePrice}元`);
                                        });
                                    } else {
                                        console.log(`⚠️ 未找到商品 ${bgmId} 的任何批号`);
                                    }
                                });
                            } else {
                                console.log('没有指定需要打折的商品列表');
                            }
                        } else {
                            console.log('折扣值未设置');
                        }
                        break;

                    case 2: // 全部恢复原价，然后再打折（支持多批号）
                        if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList) && plan.mzDiscount) {
                            // 检查是否有条件商品数量要求
                            const requiredCount = plan.mzConBgmNum || 0;
                            console.log('条件商品数量要求:', requiredCount);

                            // 找出所有符合条件的商品（支持多批号）
                            const eligibleItems = [];
                            plan.planBgmIdList.forEach(bgmId => {
                                // 使用 filter 获取所有匹配的批号
                                const matchingItems = this.cartItems.filter(item => item.bgmId === bgmId && !item.isGift);
                                if (matchingItems.length > 0) {
                                    eligibleItems.push(...matchingItems);
                                    console.log(`📦 原品打折恢复原价 - 商品 ${bgmId} 找到 ${matchingItems.length} 个批号`);
                                }
                            });

                            console.log(`🔄 符合条件商品总数（包含所有批号）: ${eligibleItems.length}`);
                            eligibleItems.forEach((item, index) => {
                                const originalPrice = Number(item.price); // 统一零售价
                                console.log(`处理批号 ${index + 1}: ${item.bgmName} (批号: ${item.sterBatchno || '无'}), 原价: ${originalPrice}元`);

                                // 全部恢复原价并打折（单价保留4位小数）
                                item.changePrice = Number(this.$common.getDecimalInfo(3, originalPrice * plan.mzDiscount));
                                item.actualPrice = item.changePrice;
                                item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                                item.discountInfo = `${plan.planName}(批号:${item.sterBatchno || '无'})：全部恢复原价后${(plan.mzDiscount * 100).toFixed(1)}折`;
                                item.mzConType = plan.mzConType;
                                item.mzGiftType = plan.mzGiftType;
                                item.planType = plan.planType;
                                item.isDiscounted = true;

                                console.log(`✅ 原品打折批号 ${item.sterBatchno || '无'} 恢复原价后打折完成: 原价${originalPrice}元, 折后价${item.changePrice}元`);
                            });

                        } else {
                            console.log('没有指定需要处理的商品列表或折扣值未设置');
                        }
                        break;


                    default:
                        console.log('未知的价格设置方式:', priceSet);
                }

            } else {
                console.log('未满足条件，不应用价格规则');
            }

            // 更新总计金额
            this.updateTotal();
        },
        mzReduce(plan) {
            console.log("按商品分类原品金额减免促销（支持多批号）");
            console.log("newPromotions", plan);

            // 1. 首先检查条件商品是否满足
            let conditionMet = false;
            let matchedConditionItems = [];

            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 记录购物车中满足条件的商品
                const conditionItemsInCart = [];

                // 遍历条件商品列表（支持多批号）
                plan.planBgmIdList.forEach(conditionItem => {
                    // 使用 filter 获取所有匹配的批号，而不是只找第一个
                    const matchedCartItems = this.cartItems.filter(item => item.bgmId === conditionItem && !item.isGift);

                    if (matchedCartItems.length > 0) {
                        console.log(`🛒 原品减免 - 找到商品 ${conditionItem} 的 ${matchedCartItems.length} 个批号`);

                        // 计算所有批号的总数量
                        const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);

                        // 为每个批号创建条件项
                        matchedCartItems.forEach((matchedCartItem) => {
                            console.log(`找到匹配商品: ${matchedCartItem.bgmName} (批号: ${matchedCartItem.sterBatchno || '无'}), 数量: ${matchedCartItem.quantity}`);
                            conditionItemsInCart.push({
                                cartItem: matchedCartItem,
                                conditionItem: conditionItem,
                                required: conditionItem.num || 1,
                                actual: matchedCartItem.quantity,
                                totalQuantity: totalQuantity, // 该商品所有批号的总数量
                                batchInfo: `批号: ${matchedCartItem.sterBatchno || '无'}`
                            });
                        });

                        console.log(`📦 商品 ${conditionItem} 共 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                    } else {
                        console.log(`⚠️ 原品减免 - 未找到商品 ${conditionItem} 的任何批号`);
                    }
                });

                // 检查是否满足所有条件商品要求
                if (conditionItemsInCart.length > 0) {
                    // 检查每个条件商品的数量是否满足要求（按商品汇总检查）
                    const itemQuantityMap = new Map();
                    conditionItemsInCart.forEach(item => {
                        const bgmId = item.conditionItem;
                        if (!itemQuantityMap.has(bgmId)) {
                            itemQuantityMap.set(bgmId, { required: item.required, actual: 0 });
                        }
                        itemQuantityMap.get(bgmId).actual += item.actual;
                    });

                    const allConditionsMet = Array.from(itemQuantityMap.values()).every(item => item.actual >= item.required);

                    if (allConditionsMet) {
                        conditionMet = true;
                        matchedConditionItems = conditionItemsInCart;
                        console.log('✅ 满足所有条件商品要求（多批号）');
                    } else {
                        console.log('❌ 条件商品数量不满足要求（多批号）');
                    }
                } else {
                    console.log('购物车中没有找到条件商品');
                }
            } else if (plan.mzConBgmNum) {
                // 如果只有数量要求，不指定具体商品，则检查购物车总数量
                const totalQuantity = this.cartItems.reduce((sum, item) => sum + item.quantity, 0);
                if (totalQuantity >= plan.mzConBgmNum) {
                    conditionMet = true;
                    console.log('满足总数量要求:', totalQuantity, '>=', plan.mzConBgmNum);
                } else {
                    console.log('不满足总数量要求:', totalQuantity, '<', plan.mzConBgmNum);
                }
            }
            // 2. 如果条件满足，根据priceSet处理价格
            if (conditionMet) {
                // 获取priceSet值，默认为1
               const priceSet = plan.conBgmTypeList && plan.conBgmTypeList.length > 0 ?
                    (plan.conBgmTypeList[0].priceSet || 1) : 1;
                console.log('价格设置方式 priceSet:', priceSet);
                // 根据不同的priceSet值处理价格
                switch (priceSet) {
                    case 1: // 保持现状去减免（支持多批号）
                        if (plan.mzCashBack) {
                            // 应用减免金额到指定商品（支持多批号）
                            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                                // 计算指定商品的总金额（包含所有批号）
                                let totalAmount = 0;
                                const targetItems = [];
                                plan.planBgmIdList.forEach(bgmId => {
                                    // 使用 filter 获取所有匹配的批号
                                    const matchingItems = this.cartItems.filter(item => item.bgmId === bgmId && !item.isGift);
                                    if (matchingItems.length > 0) {
                                        matchingItems.forEach((item, index) => {
                                            targetItems.push(item);
                                            const currentPrice = item.changePrice || item.price;
                                            totalAmount += currentPrice * item.quantity;
                                        });
                                    } else {
                                        console.log(`⚠️ 未找到商品 ${bgmId} 的任何批号`);
                                    }
                                });

                                if (targetItems.length > 0 && totalAmount > 0) {
                                    // 确保减免金额不超过总金额
                                    const actualDiscount = Math.min(plan.mzCashBack, totalAmount);
                            
                                    // 按比例分摊减免金额到各个商品实例（包括所有批号）
                                    targetItems.forEach((item, index) => {
                                        console.log(`🔄 处理减免商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'})`);
                                        const originalPrice = item.changePrice || item.price;
                                        const itemTotalAmount = originalPrice * item.quantity;

                                        // 计算该商品实例应分摊的减免金额
                                        const itemDiscount = (itemTotalAmount / totalAmount) * actualDiscount;

                                        // 计算减免后的单价（保留4位小数提高精度）
                                        const newPrice = Math.max(0, originalPrice - (itemDiscount / item.quantity));
                                        // item.changePrice = Number(newPrice.toFixed(4));
                                        item.changePrice = Number(this.$common.getDecimalInfo(4, newPrice));

                                        // 更新总金额（金额仍保持2位小数）
                                        item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                            
                                        
                                        // 更新实际价格(应收价)
                                        item.actualPrice = item.changePrice;
                                        // 记录详细的减免信息用于显示
                                        item.mixedPriceInfo = {
                                            originalPrice: originalPrice,
                                            discountAmount: itemDiscount,
                                            newPrice: item.changePrice,
                                            isDiscount: true,
                                            totalDiscount: plan.mzCashBack
                                        };

                                        // 添加减免信息以便显示（包含批号信息）
                                        const batchText = item.sterBatchno ? `(批号:${item.sterBatchno})` : '';
                                        item.discountInfo = `${plan.planName}${batchText}：总减免${plan.mzCashBack}元(分摊${this.$common.getDecimalInfo(3, itemDiscount)}元)`;

                                        item.mzConType = plan.mzConType;
                                        item.mzGiftType = plan.mzGiftType;
                                        item.planType = plan.planType;
                                        // 标记为已减免
                                        item.isDiscounted = true;

                                        console.log(`✅ 原品减免批号 ${item.sterBatchno || '无'} 处理完成 - 原价: ${originalPrice}元, 减免后价: ${item.changePrice.toFixed(4)}元, 分摊减免: ${this.$common.getDecimalInfo(3, itemDiscount)}元`);
                                    });
                                } else {
                                    console.log('未找到需要减免的商品或总金额为0');
                                }
                            } else {
                                console.log('没有指定需要减免的商品列表');
                            }
                        } else {
                            console.log('减免金额未设置');
                        }
                        break;

                    case 2: // 全部恢复原价，然后再减免（支持多批号）
                        if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList) && plan.mzCashBack) {
                            // 先恢复所有指定商品为原价，然后计算总金额（支持多批号）
                            let totalAmount = 0;
                            const targetItems = [];

                            plan.planBgmIdList.forEach(bgmId => {
                                console.log(`🔄 恢复原价后再减免的商品ID: ${bgmId}`);
                                // 使用 filter 获取所有匹配的批号
                                const matchingItems = this.cartItems.filter(item => item.bgmId === bgmId && !item.isGift);

                                if (matchingItems.length > 0) {
                                    console.log(`📦 原品减免恢复原价 - 商品 ${bgmId} 找到 ${matchingItems.length} 个批号`);

                                    matchingItems.forEach((item, index) => {
                                        targetItems.push(item);
                                        // 先恢复为统一零售价
                                        const originalPrice = Number(item.price);
                                        totalAmount += originalPrice * item.quantity;
                                        console.log(`批号 ${index + 1}: ${item.bgmName} (批号: ${item.sterBatchno || '无'}), 原价: ${originalPrice}元, 数量: ${item.quantity}, 小计: ${this.$common.getDecimalInfo(3, originalPrice * item.quantity)}元`);
                                    });
                                } else {
                                    console.log(`⚠️ 未找到商品 ${bgmId} 的任何批号`);
                                }
                            });

                            if (targetItems.length > 0 && totalAmount > 0) {
                                // 确保减免金额不超过总金额
                                const actualDiscount = Math.min(plan.mzCashBack, totalAmount);
                                console.log(`💰 原品减免恢复原价计算 - 总金额: ${totalAmount.toFixed(2)}元, 减免金额: ${plan.mzCashBack}元, 实际减免: ${actualDiscount.toFixed(2)}元`);
                                // 按比例分摊减免金额到各个商品实例（包括所有批号）
                                targetItems.forEach(item => {
                                    console.log(`🔄 处理恢复原价减免商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'})`);
                                    // 保存当前价格用于显示信息
                                    const currentPrice = item.changePrice || item.actualPrice;
                                    // 先恢复为统一零售价
                                    const originalPrice = Number(item.price);
                                    const itemTotalAmount = originalPrice * item.quantity;

                                    // 计算该商品实例应分摊的减免金额
                                    const itemDiscount = (itemTotalAmount / totalAmount) * actualDiscount;

                                    // 计算减免后的单价（保留4位小数提高精度）
                                    const newPrice = Math.max(0, originalPrice - (itemDiscount / item.quantity));
                                    item.changePrice = Number(newPrice.toFixed(4));

                                    // 更新总金额（金额仍保持2位小数）
                                    item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                                    // 更新实际价格(应收价)（单价保持4位小数）
                                    item.actualPrice = item.changePrice;
                                    // 记录详细的减免信息用于显示
                                    item.mixedPriceInfo = {
                                        originalPrice: originalPrice,
                                        discountAmount: itemDiscount,
                                        newPrice: item.changePrice,
                                        isDiscount: true,
                                        totalDiscount: plan.mzCashBack,
                                        isRestoreOriginal: true
                                    };

                                    // 添加价格信息以便显示（包含批号信息）
                                    const batchText = item.sterBatchno ? `(批号:${item.sterBatchno})` : '';
                                    item.discountInfo = `${plan.planName}${batchText}：恢复原价后总减免${plan.mzCashBack}元(分摊${this.$common.getDecimalInfo(3, itemDiscount)}元)`;
                                    item.mzConType = plan.mzConType;
                                    item.mzGiftType = plan.mzGiftType;
                                    item.planType = plan.planType;
                                    // 标记为已处理
                                    item.isDiscounted = true;

                                    console.log(`✅ 原品减免批号 ${item.sterBatchno || '无'} 恢复原价后减免完成 - 之前价格: ${currentPrice}元, 原价: ${originalPrice}元, 减免后: ${item.changePrice.toFixed(4)}元, 分摊减免: ${this.$common.getDecimalInfo(3, itemDiscount)}元`);
                                });
                            } else {
                                console.log('未找到需要处理的商品或总金额为0');
                            }

                            // 显示成功信息
                            // this.$message.success(`已应用价格规则：${plan.planName}，恢复原价后再减免`);
                        } else {
                            console.log('没有指定需要处理的商品列表或减免金额未设置');
                        }
                        break;

               
                    default:
                        console.log('未知的价格设置方式:', priceSet);
                }

            } else {
                console.log('未满足条件，不应用价格规则');
            }

            // 更新总计金额
            this.updateTotal();
        },

        /**
         * 处理满赠促销中的积分计算
         * @param {Object} plan - 促销方案
         * @param {number} priceSet - 价格设置方式
         */
        handlePointsPromotionForMz(plan, priceSet) {
            console.log('🎯 处理满赠促销中的积分计算（支持多批号）', plan.planName, 'priceSet:', priceSet);

            // 检查是否有积分设置
            if (!plan.mzAddPoint && !plan.mzReducePoint) {
                console.log('该促销方案没有积分设置，跳过积分处理');
                return;
            }

            // 计算重复赠送倍数（支持多批号）
            let mzIsRepeatNum = 1;
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量（支持多批号）
                let qualifiedQuantity = 0;

                if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                    // 如果有指定条件商品，计算所有批号的总数量
                    plan.planBgmIdList.forEach((conditionItem) => {
                        // 使用 filter 获取所有匹配的批号
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === conditionItem && !item.isGift
                        );

                        if (matchedCartItems.length > 0) {
                            // 计算所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);
                            qualifiedQuantity += totalQuantity;

                            console.log(`📦 积分计算 - 商品 ${conditionItem} 共 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                        }
                    });
                }

                // 根据条件商品数量要求计算积分倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);

                console.log(
                    `🎯 积分促销重复计算（多批号）: 符合条件商品总数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 积分倍数=${mzIsRepeatNum}`
                );

                // 如果倍数为0，说明不满足条件，不赠送积分
                if (mzIsRepeatNum <= 0) {
                    console.log('❌ 不满足重复赠送条件，不赠送积分');
                    return;
                }
            }

            // 分别计算总积分
            const totalAddPoint = (plan.mzAddPoint || 0) * mzIsRepeatNum;
            const totalReducePoint = (plan.mzReducePoint || 0) * mzIsRepeatNum;

            console.log(`💰 积分计算结果: 基础增加积分=${plan.mzAddPoint || 0}, 基础减少积分=${plan.mzReducePoint || 0}, 倍数=${mzIsRepeatNum}, 总增加积分=${totalAddPoint}, 总减少积分=${totalReducePoint}`);

            // 获取参与积分促销的商品列表（支持多批号）
            const participatingItems = [];
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                plan.planBgmIdList.forEach(bgmId => {
                    // 使用 filter 获取所有匹配的批号
                    const matchedItems = this.cartItems.filter(item => item.bgmId === bgmId && !item.isGift);
                    if (matchedItems.length > 0) {
                        participatingItems.push(...matchedItems);
                        console.log(`📦 积分分配 - 商品 ${bgmId} 找到 ${matchedItems.length} 个批号`);
                    }
                });
            }

            if (participatingItems.length === 0) {
                console.log('❌ 没有找到参与积分促销的商品');
                return;
            }

            console.log(`📊 参与积分促销的商品总数（包含所有批号）: ${participatingItems.length}`);

            // 计算每个商品实例应分配的积分（平分到所有批号）
            const addPointPerItem = Math.floor(totalAddPoint / participatingItems.length);
            const reducePointPerItem = Math.floor(totalReducePoint / participatingItems.length);

            // 计算剩余积分（用于分配给前几个商品实例）
            const remainingAddPoint = totalAddPoint % participatingItems.length;
            const remainingReducePoint = totalReducePoint % participatingItems.length;

            console.log(`💰 积分平分计算（多批号）: 参与商品实例数=${participatingItems.length}, 每个实例增加积分=${addPointPerItem}, 每个实例减少积分=${reducePointPerItem}, 剩余增加积分=${remainingAddPoint}, 剩余减少积分=${remainingReducePoint}`);

            // 处理参与积分促销的每个商品实例（包括所有批号）
            participatingItems.forEach((item, index) => {
                console.log(`🔄 处理积分促销商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'})`);

                // 根据priceSet处理价格（注意：case 2 的价格处理已经在主流程中完成）
                switch (priceSet) {
                    case 1: // 保持现状，不改变价格，只添加积分标记
                        const currentPrice = item.changePrice || item.price;
                        item.changePrice = currentPrice;
                        item.actualPrice = currentPrice;
                        item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                        break;

                    case 2: // 恢复原价后添加积分标记（价格已在主流程处理，这里只确保一致性）
                        // 价格已经在主流程的 case 2 中处理过了，这里不需要重复处理
                        // 只需要确保金额计算正确
                        item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                        break;

                    default:
                        console.log('⚠️ 未知的价格设置方式:', priceSet);
                        break;
                }

                // 计算该商品实例的积分（前几个商品实例分配剩余积分）
                const itemAddPoint = addPointPerItem + (index < remainingAddPoint ? 1 : 0);
                const itemReducePoint = reducePointPerItem + (index < remainingReducePoint ? 1 : 0);

                // 添加积分促销信息
                let pointInfo = '';
                if (itemAddPoint > 0 && itemReducePoint > 0) {
                    pointInfo = `+${itemAddPoint}积分，-${itemReducePoint}积分`;
                } else if (itemAddPoint > 0) {
                    pointInfo = `+${itemAddPoint}积分`;
                } else if (itemReducePoint > 0) {
                    pointInfo = `-${itemReducePoint}积分`;
                }

                // 更新商品的积分信息和状态
                item.addPoint = itemAddPoint;
                item.rePoint = itemReducePoint;
                item.repeatMultiple = mzIsRepeatNum; // 记录倍数
                item.isPointPromotion = true;
                item.mzConType = plan.mzConType;
                item.mzGiftType = plan.mzGiftType;
                item.planType = plan.planType;
                item.isDiscounted = true;

                // 更新显示信息（包含批号信息）
                const priceSetText = priceSet === 2 ? '恢复原价后' : '';
                const multipleText = mzIsRepeatNum > 1 ? `(${mzIsRepeatNum}倍)` : '';
                const batchText = item.sterBatchno ? `(批号:${item.sterBatchno})` : '';
                item.discountInfo = `${plan.planName}${batchText}：${priceSetText}${pointInfo}${multipleText}`;

                console.log(`✅ 积分促销商品处理完成 - 商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'}), 价格: ${item.changePrice}元, 分配增加积分: ${itemAddPoint}, 分配减少积分: ${itemReducePoint}, 倍数: ${mzIsRepeatNum}`);
            });

            // 更新总积分
            this.updateTotalPoints(totalAddPoint, totalReducePoint);
        },

        /**
         * 更新总积分
         * @param {number} addPoint - 增加的积分
         * @param {number} reducePoint - 减少的积分
         */
        updateTotalPoints(addPoint, reducePoint) {
            // 如果父组件有相关的积分总计属性，在这里更新
            if (this.totalAddPoint !== undefined) {
                this.totalAddPoint = (this.totalAddPoint || 0) + addPoint;
            }
            if (this.totalReducePoint !== undefined) {
                this.totalReducePoint = (this.totalReducePoint || 0) + reducePoint;
            }

            console.log(`总积分更新: 增加积分=${addPoint}, 减少积分=${reducePoint}`);
        },

        /**
         * 处理优惠券促销中的积分计算
         * @param {Object} plan - 促销方案
         * @param {number} priceSet - 价格设置方式
         * @param {number} mzIsRepeatNum - 重复倍数
         */
        handlePointsPromotionForYhq(plan, priceSet, mzIsRepeatNum) {
            console.log('🎯 处理优惠券促销中的积分计算（支持多批号）', plan.planName, 'priceSet:', priceSet, '倍数:', mzIsRepeatNum);

            // 检查是否有积分设置
            if (!plan.mzAddPoint && !plan.mzReducePoint) {
                console.log('该优惠券促销方案没有积分设置，跳过积分处理');
                return;
            }

            // 分别计算总积分
            const totalAddPoint = (plan.mzAddPoint || 0) * mzIsRepeatNum;
            const totalReducePoint = (plan.mzReducePoint || 0) * mzIsRepeatNum;

            console.log(`💰 优惠券积分计算结果: 基础增加积分=${plan.mzAddPoint || 0}, 基础减少积分=${plan.mzReducePoint || 0}, 倍数=${mzIsRepeatNum}, 总增加积分=${totalAddPoint}, 总减少积分=${totalReducePoint}`);

            // 获取参与积分促销的商品列表（支持多批号）
            const participatingItems = [];
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                plan.planBgmIdList.forEach(bgmId => {
                    // 使用 filter 获取所有匹配的批号
                    const matchedItems = this.cartItems.filter(item => item.bgmId === bgmId && !item.isGift);
                    if (matchedItems.length > 0) {
                        participatingItems.push(...matchedItems);
                        console.log(`📦 优惠券积分分配 - 商品 ${bgmId} 找到 ${matchedItems.length} 个批号`);
                    }
                });
            }

            if (participatingItems.length === 0) {
                console.log('❌ 没有找到参与优惠券积分促销的商品');
                return;
            }

            console.log(`📊 参与优惠券积分促销的商品总数（包含所有批号）: ${participatingItems.length}`);

            // 计算每个商品实例应分配的积分（平分到所有批号）
            const addPointPerItem = Math.floor(totalAddPoint / participatingItems.length);
            const reducePointPerItem = Math.floor(totalReducePoint / participatingItems.length);

            // 计算剩余积分（用于分配给前几个商品实例）
            const remainingAddPoint = totalAddPoint % participatingItems.length;
            const remainingReducePoint = totalReducePoint % participatingItems.length;

            console.log(`💰 优惠券积分平分计算（多批号）: 参与商品实例数=${participatingItems.length}, 每个实例增加积分=${addPointPerItem}, 每个实例减少积分=${reducePointPerItem}, 剩余增加积分=${remainingAddPoint}, 剩余减少积分=${remainingReducePoint}`);

            // 处理参与积分促销的每个商品实例（包括所有批号）
            participatingItems.forEach((item, index) => {
                console.log(`🔄 处理优惠券积分促销商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'})`);

                // 根据priceSet处理价格
                switch (priceSet) {
                    case 1: // 保持现状，不改变价格，只添加积分标记
                        const currentPrice = item.changePrice || item.price;
                        item.changePrice = currentPrice;
                        item.actualPrice = currentPrice;
                        item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                        
                        break;

                    case 2: // 恢复原价后添加积分标记
                        const originalPrice = Number(item.price);
                        item.changePrice = originalPrice;
                        item.actualPrice = originalPrice;
                        item.amount = Number(this.$common.getDecimalInfo(3, originalPrice * item.quantity));
                        break;

                    default:
                        console.log('⚠️ 未知的价格设置方式:', priceSet);
                        break;
                }

                // 计算该商品实例的积分（前几个商品实例分配剩余积分）
                const itemAddPoint = addPointPerItem + (index < remainingAddPoint ? 1 : 0);
                const itemReducePoint = reducePointPerItem + (index < remainingReducePoint ? 1 : 0);

                // 添加积分促销信息
                let pointInfo = '';
                if (itemAddPoint > 0 && itemReducePoint > 0) {
                    pointInfo = `+${itemAddPoint}积分，-${itemReducePoint}积分`;
                } else if (itemAddPoint > 0) {
                    pointInfo = `+${itemAddPoint}积分`;
                } else if (itemReducePoint > 0) {
                    pointInfo = `-${itemReducePoint}积分`;
                }

                // 更新商品的积分信息和状态
                item.addPoint = itemAddPoint;
                item.rePoint = itemReducePoint;
                item.repeatMultiple = mzIsRepeatNum; // 记录倍数
                item.isPointPromotion = true;
                item.mzConType = plan.mzConType;
                item.mzGiftType = plan.mzGiftType;
                item.planType = plan.planType;
                item.isDiscounted = true;

                // 更新显示信息（包含批号信息）
                const priceSetText = priceSet === 2 ? '恢复原价后' : '';
                const multipleText = mzIsRepeatNum > 1 ? `(${mzIsRepeatNum}倍)` : '';
                const batchText = item.sterBatchno ? `(批号:${item.sterBatchno})` : '';
                item.discountInfo = `${plan.planName}${batchText}：${priceSetText}${pointInfo}${multipleText}`;

                console.log(`✅ 优惠券积分促销商品处理完成 - 商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'}), 价格: ${item.changePrice}元, 分配增加积分: ${itemAddPoint}, 分配减少积分: ${itemReducePoint}, 倍数: ${mzIsRepeatNum}`);
            });

            // 更新总积分
            this.updateTotalPoints(totalAddPoint, totalReducePoint);
        },

        /**
         * 处理积分促销中的积分计算
         * @param {Object} plan - 促销方案
         * @param {number} priceSet - 价格设置方式
         */
        handlePointsPromotionForJifen(plan, priceSet) {
            console.log('🎯 处理积分促销中的积分计算（支持多批号）', plan.planName, 'priceSet:', priceSet);

            // 检查是否有积分设置
            if (!plan.mzAddPoint && !plan.mzReducePoint) {
                console.log('该积分促销方案没有积分设置，跳过积分处理');
                return;
            }

            // 计算重复赠送倍数（支持多批号）
            let mzIsRepeatNum = 1;
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量（支持多批号）
                let qualifiedQuantity = 0;

                if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                    // 如果有指定条件商品，计算所有批号的总数量
                    plan.planBgmIdList.forEach((conditionItem) => {
                        // 使用 filter 获取所有匹配的批号
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === conditionItem && !item.isGift
                        );

                        if (matchedCartItems.length > 0) {
                            // 计算所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce((sum, item) => sum + item.quantity, 0);
                            qualifiedQuantity += totalQuantity;

                            console.log(`📦 积分促销计算 - 商品 ${conditionItem} 共 ${matchedCartItems.length} 个批号，总数量: ${totalQuantity}`);
                        }
                    });
                }

                // 根据条件商品数量要求计算积分倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);

                console.log(
                    `🎯 积分促销重复计算（多批号）: 符合条件商品总数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 积分倍数=${mzIsRepeatNum}`
                );

                // 如果倍数为0，说明不满足条件，不赠送积分
                if (mzIsRepeatNum <= 0) {
                    console.log('❌ 不满足重复赠送条件，不赠送积分');
                    return;
                }
            }

            // 分别计算总积分
            const totalAddPoint = (plan.mzAddPoint || 0) * mzIsRepeatNum;
            const totalReducePoint = (plan.mzReducePoint || 0) * mzIsRepeatNum;

            console.log(`💰 积分促销积分计算结果: 基础增加积分=${plan.mzAddPoint || 0}, 基础减少积分=${plan.mzReducePoint || 0}, 倍数=${mzIsRepeatNum}, 总增加积分=${totalAddPoint}, 总减少积分=${totalReducePoint}`);

            // 获取参与积分促销的商品列表（支持多批号）
            const participatingItems = [];
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                plan.planBgmIdList.forEach(bgmId => {
                    // 使用 filter 获取所有匹配的批号
                    const matchedItems = this.cartItems.filter(item => item.bgmId === bgmId && !item.isGift);
                    if (matchedItems.length > 0) {
                        participatingItems.push(...matchedItems);
                        console.log(`📦 积分促销分配 - 商品 ${bgmId} 找到 ${matchedItems.length} 个批号`);
                    }
                });
            }

            if (participatingItems.length === 0) {
                console.log('❌ 没有找到参与积分促销的商品');
                return;
            }

            console.log(`📊 参与积分促销的商品总数（包含所有批号）: ${participatingItems.length}`);

            // 计算每个商品实例应分配的积分（平分到所有批号）
            const addPointPerItem = Math.floor(totalAddPoint / participatingItems.length);
            const reducePointPerItem = Math.floor(totalReducePoint / participatingItems.length);

            // 计算剩余积分（用于分配给前几个商品实例）
            const remainingAddPoint = totalAddPoint % participatingItems.length;
            const remainingReducePoint = totalReducePoint % participatingItems.length;

            console.log(`💰 积分促销积分平分计算（多批号）: 参与商品实例数=${participatingItems.length}, 每个实例增加积分=${addPointPerItem}, 每个实例减少积分=${reducePointPerItem}, 剩余增加积分=${remainingAddPoint}, 剩余减少积分=${remainingReducePoint}`);

            // 处理参与积分促销的每个商品实例（包括所有批号）
            participatingItems.forEach((item, index) => {
                console.log(`🔄 处理积分促销商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'})`);

                // 根据priceSet处理价格（注意：case 2 的价格处理已经在主流程中完成）
                switch (priceSet) {
                    case 1: // 保持现状，不改变价格，只添加积分标记
                        const currentPrice = item.changePrice || item.price;
                        item.changePrice = currentPrice;
                        item.actualPrice = currentPrice;
                        item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                        break;

                    case 2: // 恢复原价后添加积分标记（价格已在主流程处理，这里只确保一致性）
                        // 价格已经在主流程的 case 2 中处理过了，这里不需要重复处理
                        // 只需要确保金额计算正确
                        item.amount = Number(this.$common.getDecimalInfo(3, item.changePrice * item.quantity));
                        break;

                    default:
                        console.log('⚠️ 未知的价格设置方式:', priceSet);
                        break;
                }

                // 计算该商品实例的积分（前几个商品实例分配剩余积分）
                const itemAddPoint = addPointPerItem + (index < remainingAddPoint ? 1 : 0);
                const itemReducePoint = reducePointPerItem + (index < remainingReducePoint ? 1 : 0);

                // 添加积分促销信息
                let pointInfo = '';
                if (itemAddPoint > 0 && itemReducePoint > 0) {
                    pointInfo = `+${itemAddPoint}积分，-${itemReducePoint}积分`;
                } else if (itemAddPoint > 0) {
                    pointInfo = `+${itemAddPoint}积分`;
                } else if (itemReducePoint > 0) {
                    pointInfo = `-${itemReducePoint}积分`;
                }

                // 更新商品的积分信息和状态
                item.addPoint = itemAddPoint;
                item.rePoint = itemReducePoint;
                item.repeatMultiple = mzIsRepeatNum; // 记录倍数
                item.isPointPromotion = true;
                item.mzConType = plan.mzConType;
                item.mzGiftType = plan.mzGiftType;
                item.planType = plan.planType;
                item.isDiscounted = true;

                // 更新显示信息（包含批号信息）
                let priceSetText = '';
                switch (priceSet) {
                    case 2:
                        priceSetText = '恢复原价后';
                        break;
                    case 3:
                        priceSetText = '部分恢复原价后';
                        break;
                    default:
                        priceSetText = '';
                        break;
                }
                const multipleText = mzIsRepeatNum > 1 ? `(${mzIsRepeatNum}倍)` : '';
                const batchText = item.sterBatchno ? `(批号:${item.sterBatchno})` : '';
                item.discountInfo = `${plan.planName}${batchText}：${priceSetText}${pointInfo}${multipleText}`;

                console.log(`✅ 积分促销商品处理完成 - 商品: ${item.bgmName} (批号: ${item.sterBatchno || '无'}), 价格: ${item.changePrice}元, 分配增加积分: ${itemAddPoint}, 分配减少积分: ${itemReducePoint}, 倍数: ${mzIsRepeatNum}`);
            });

            // 更新总积分
            this.updateTotalPoints(totalAddPoint, totalReducePoint);
        }
    },
};
